import { Controller } from "@hotwired/stimulus";

// Renders a Unix epoch (seconds, may be fractional) as text in the viewer's
// local time. Mo chat messages render both on initial page load and via
// background broadcasts, neither of which carries the viewer's time zone, so
// formatting has to happen client-side.
//
// format: "datetime" (default) -> 7/14/2026, 5:12 PM
//         "time"               -> 5:12:54.208 PM
export default class extends Controller {
  static values = {
    epoch: Number,
    format: { type: String, default: "datetime" },
  };

  connect() {
    const date = new Date(this.epochValue * 1000);
    const options =
      this.formatValue === "time"
        ? {
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            fractionalSecondDigits: 3,
          }
        : {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
          };
    this.element.textContent = date.toLocaleString(undefined, options);
  }
}
